import clsx from "clsx";
import Card from "../Card";
import cardContent from "./cardContent";
import stripHTML from "@/helpers/stripHTML";
import { useEffect, useState } from "react";

const InspoGrid = ({
  expanded,
  selected,
  onSearchSubmit = () => {}
}: {
  expanded: boolean;
  selected: string;
  onSearchSubmit?: (query: boolean) => void;
}) => {
  const [search, setSearch] = useState(null) 
  useEffect(() => {
    setSearch(searchPromptDetails);
  },[])
  return (
    <div
      className={clsx(
        expanded
          ? "mx-auto lg:max-w-[912px] xl:max-w-full grid-cols-1 sm:grid-cols-2 mb-[24px]"
          : "grid-cols-1 gridCustom:grid-cols-2 xl:grid-cols-3 ",
        "grid w-full gap-4"
      )}
    >
      {!expanded ? (
        <>
        {
          searchPromptDetails.cards.map((card, index) => {
            if(index <  searchPromptDetails.cards.length -1) {
              return  <Card
              key={card.id}
              expanded={expanded}
              onSearchSubmit = {onSearchSubmit}
              title={card.description}
              expandedDescription="Embark on a journey to the sun-drenched shores of the Mediterranean."
              description={card.subheading}
              image={card.src}
              imagePriority="high"
              searchTerm={stripHTML(card.description)}
              dataReason={stripHTML(card.description)}
            />
            } else {
              return  <div key={card.id} className="block xl:hidden">
              <Card
            
              expanded={expanded}
              onSearchSubmit = {onSearchSubmit}
              title={card.description}
              expandedDescription="Embark on a journey to the sun-drenched shores of the Mediterranean."
              description={card.subheading}
              image={card.src}
              imagePriority="high"
              searchTerm={stripHTML(card.description)}
              dataReason={stripHTML(card.description)}
             />
            </div>
            }
          }
         )
        }
        </>
      ) : null}

      {expanded &&
        cardContent
          .filter((card) => card.category === selected)
          .map((card) => {
            return <Card {...card} key={card.id} onSearchSubmit={onSearchSubmit}/>;
          })}
    </div>
  );
};

export default InspoGrid;
